import * as React from 'react';
import classnames from 'classnames';

import Link from 'libs/router/Link';

import GalleryModal from 'components/gallery-modal/gallery-modal/GalleryModal';
import { withModal } from 'components/modal/ModalHOC';
import ConsentPlaceholder from 'components/consent-placeholder/ConsentPlaceholder';

import DiscoveryContentImageOverlay from './overlay/DiscoveryContentImageOverlay';
import DiscoveryContentResultsContext from '../context/DiscoveryContentResultsContext';
import DiscoveryContentModalAsset from '../asset/DiscoveryContentModalAsset';

import { WITH_GALLERY_MODAL_CONFIG } from 'utils/gallery';
import { CHANNEL_TYPE_INSTAGRAM } from 'utils/channels';

import './discovery-content-results-image.scss';

import type { DiscoveryContentResultImage } from 'types';
import type { ConsentReducerConsentsMap } from 'redux-store/types/ConsentReducer.type';

type Props = {
  userChannelConsents: ConsentReducerConsentsMap,
  item: DiscoveryContentResultImage,
  index: number,
  isFullScreen: boolean,
  onGalleryModalLastPage: () => void
};

const ImageWithModal = withModal(<img alt="" />, {
  ...WITH_GALLERY_MODAL_CONFIG,
  modalContent: (props) => (
    <DiscoveryContentResultsContext.Consumer>
      {(results) => <GalleryModal {...props} items={results} />}
    </DiscoveryContentResultsContext.Consumer>
  )
});

const PlaceholderWithModal = withModal((
  <ConsentPlaceholder
    withLearnMore
    type="instagram"
  />
), {
  ...WITH_GALLERY_MODAL_CONFIG,
  modalContent: (props) => (
    <DiscoveryContentResultsContext.Consumer>
      {(results) => <GalleryModal {...props} items={results} />}
    </DiscoveryContentResultsContext.Consumer>
  )
});

class DiscoveryContentResultsImage extends React.PureComponent<Props> {
  renderItemOverlay(): React.ReactNode {
    const { item, isFullScreen } = this.props;
    const size = isFullScreen ? 'large' : 'small';

    return (
      <DiscoveryContentImageOverlay
        likes={item.likes}
        comments={item.comments}
        engagementRate={item.engagementRate}
        date={item.date}
        size={size}
        icon={{
          width: isFullScreen ? 14 : 10,
          height: isFullScreen ? 14 : 10
        }}
      />
    );
  }

  renderImage(): React.ReactNode {
    const { item, index, onGalleryModalLastPage, userChannelConsents } = this.props;
    const imageClasses = classnames('lazyload', 'discovery-content-results-image__image');

    const modalContentProps = {
      theme: 'white',
      onLastPage: onGalleryModalLastPage,
      currentPosition: index,
      className: 'discovery-content-results-image__modal',
      itemClassName: 'discovery-content-results-image__modal-item',
      renderCustomAsset: (selectedItem, currentPosition) => (
        <DiscoveryContentModalAsset
          selectedItem={selectedItem}
          currentPosition={currentPosition}
        />
      )
    };

    if (userChannelConsents[CHANNEL_TYPE_INSTAGRAM]) {
      return (
        <ImageWithModal
          modalContentProps={modalContentProps}
          className={imageClasses}
          data-src={item.assetUrl}
        />
      );
    }

    return (
      <div className="discovery-content-results__results-placeholder">
        <PlaceholderWithModal
          link={item.url}
          modalContentProps={modalContentProps}
        />
      </div>
    );
  }

  renderItem(): React.ReactNode {
    const { item } = this.props;

    return (
      <div className="discovery-content-results-image__item">
        <Link
          to={item.url}
          target="_blank"
        >
          {this.renderImage()}
        </Link>
        {this.renderItemOverlay()}
      </div>
    );
  }

  render(): React.ReactNode {
    return (
      <div className="discovery-content-results-image">
        {this.renderItem()}
      </div>
    );
  }
}

export default DiscoveryContentResultsImage;
